import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import RouteSeo from "../seo/RouteSeo";

import Home from "../MainPages/HomePage";
import Upis from "../MainPages/UpisPage";
import Programi from "../MainPages/ProgramiPage";
import Onama from "../MainPages/OnamaPage";
import MedjunarodnaSaradnja from "../MainPages/MedjunarodnaSaradnjaPage";
import Studenti from "../MainPages/StudentiPage";
import Galerija from "../MainPages/GalerijaPage";
import Novosti from "../MainPages/NovostiPage";
import NovostiDetailPage from "../MainPages/NovostiDetailPage";
import Kontakt from "../MainPages/KontaktPage";
import SummerSchoolBar2026Page from "../MainPages/SummerSchoolBar2026Page";

import UpisniRokovi from "../components/Upis/UpisniRokovi";
import CijeneStudija from "../components/Upis/CijeneStudija";
import PrelazakSaDrugihFakulteta from "../components/Upis/PrelazakSaDrugihFakulteta";
import AkreditacijaFpep from "../components/Upis/AkreditacijaFpep";

import RacFinBan from "../components/Programi/RacFinBan";
import Menadzment from "../components/Programi/Menadzment";
import PravoOsnovne from "../components/Programi/PravoOsnovne";
import PoslovnaEkonomija from "../components/Programi/PoslovnaEkonomija";
import EkonomijaJavnogSektora from "../components/Programi/EkonomijaJavnogSektora";
import PravoMaster from "../components/Programi/PravoMaster";
import MenadzmentJavnogSektora from "../components/Programi/MenadzmentJavnogSektora";
import MenadzmentProfitnogSektora from "../components/Programi/MenadzmentProfitnogSektora";
import SpecijalistickeObavjestenje from "../components/Programi/SpecijalistickeObavjestenje";

import ProjectSingleKA171 from "../components/Projekti/ProjectSingleKA171";
import ProjectSingleRESUNI from "../components/Projekti/ProjectSingleRESUNI";
import ProjectSingleLANDS from "../components/Projekti/ProjectSingleLANDS";
import ProjectSingleREIMAGINE from "../components/Projekti/ProjectSingleREIMAGINE";
import ProjectSinglePRODIGYE from "../components/Projekti/ProjectSinglePRODIGYE";

import OsnoviEkonomije from "../components/RFBPredmeti/OsnoviEkonomije";
import EkonomikaPreduzeca from "../components/RFBPredmeti/EkonomikaPreduzeca";
import MatematickoStatistickeMetode from "../components/RFBPredmeti/MatematickoStatistickeMetode";
import PoslovnaInformatika from "../components/RFBPredmeti/PoslovnaInformatika";
import MenadzmentPredmet from "../components/RFBPredmeti/MenadzmentPredmet";
import RacunovodstvoPredmet from "../components/RFBPredmeti/RacunovodstvoPredmet";
import OsnoviKompanijskogTrgovinskogPrava from "../components/RFBPredmeti/OsnoviKompanijskogTrgovinskogPrava";
import EngleskiJezik1 from "../components/RFBPredmeti/EngleskiJezik1";
import MenadzmentLjudskihResursa from "../components/RFBPredmeti/MenadzmentLjudskihResursa";
import ElektronskoPoslovanje from "../components/RFBPredmeti/ElektronskoPoslovanje";
import OsnoviPreduzetnistva from "../components/RFBPredmeti/OsnoviPreduzetnistva";
import Marketing from "../components/RFBPredmeti/Marketing";
import PoslovneFinansije from "../components/RFBPredmeti/PoslovneFinansije";
import Bankarstvo from "../components/RFBPredmeti/Bankarstvo";
import UpravljackoRacunovodstvo from "../components/RFBPredmeti/UpravljackoRacunovodstvo";
import EngleskiJezik2 from "../components/RFBPredmeti/EngleskiJezik2";
import UpravljanjeKvalitetom from "../components/RFBPredmeti/UpravljanjeKvalitetom";
import MenadzmentMalihSrednjihPreduzeca from "../components/RFBPredmeti/MenadzmentMalihSrednjihPreduzeca";
import Sociologija from "../components/RFBPredmeti/Sociologija";
import Logistika from "../components/RFBPredmeti/Logistika";
import PoslovnoOdlucivanje from "../components/RFBPredmeti/PoslovnoOdlucivanje";
import PoslovnaKulturaOrganizacionoPonasanje from "../components/RFBPredmeti/PoslovnaKulturaOrganizacionoPonasanje";
import AnalizaPoslovanja from "../components/RFBPredmeti/AnalizaPoslovanja";
import KontrolaRevizija from "../components/RFBPredmeti/KontrolaRevizija";
import FinansijskaTrzistaBerzanskoPoslovanje from "../components/RFBPredmeti/FinansijskaTrzistaBerzanskoPoslovanje";
import MonetarneJavneFinansije from "../components/RFBPredmeti/MonetarneJavneFinansije";
import CarinskoPoslovanje from "../components/RFBPredmeti/CarinskoPoslovanje";
import TransportSpedicijaOsiguranje from "../components/RFBPredmeti/TransportSpedicijaPoslovanje";
import MenadzmentUSportu from "../components/RFBPredmeti/MenadzmentUSportu";
import EkonomikaSportskihDogadjaja from "../components/RFBPredmeti/EkonomikaSportskihDogadjaja";

import OsnoviEkonomijeM from "../components/MOASPredmeti/OsnoviEkonomijeM";
import PoslovnaEkonomikaM from "../components/MOASPredmeti/PoslovnaEkonomikaM";
import MatematickoStatistickeMetodeM from "../components/MOASPredmeti/MatematickoStatistickeMetodeM";
import MenadzmentPredmetM from "../components/MOASPredmeti/MenadzmentPredmetM";
import RacunovodstvoPredmetM from "../components/MOASPredmeti/RacunovodstvoPredmetM";
import PoslovnaInformatikaM from "../components/MOASPredmeti/PoslovnaInformatikaM";
import OsnoviKompanijskogTrgovinskogPravaM from "../components/MOASPredmeti/OsnoviKompanijskogTrgovinskogPravoM";
import EngleskiJezik1M from "../components/MOASPredmeti/EngleskiJezik1M";
import MenadzmentLjudskihResursaM from "../components/MOASPredmeti/MenadzmentLjudskihResursaM";
import ElektronskoPoslovanjeM from "../components/MOASPredmeti/ElektronskoPoslovanjeM";
import OsnoviPreduzetnistvaM from "../components/MOASPredmeti/OsnoviPreduzetnistvaM";
import MarketingM from "../components/MOASPredmeti/MarketingM";
import StrategijskiMenadzment from "../components/MOASPredmeti/StrategijskiMenadzment";
import OdrziviRazvoj from "../components/MOASPredmeti/OdrziviRazvoj";
import UpravljackoRacunovodstvoM from "../components/MOASPredmeti/UpravljackoRacunovodstvoM";
import EngleskiJezik2M from "../components/MOASPredmeti/EngleskiJezik2M";
import UpravljanjeKvalitetomM from "../components/MOASPredmeti/UpravljanjeKvalitetomM";
import MenadzmentMalihSrednjihPreduzecaM from "../components/MOASPredmeti/MenadzmentMalihSrednjihPreduzecaM";
import SociologijaM from "../components/MOASPredmeti/SociologijaM";
import LogistikaM from "../components/MOASPredmeti/LogistikaM";
import PoslovnoOdlucivanjeM from "../components/MOASPredmeti/PoslovnoOdlucivanjeM";
import PoslovnaKulturaOrganizacionoPonasanjeM from "../components/MOASPredmeti/PoslovnaKulturaOrganizacionoPonasanjeM";
import AnalizaPoslovanjaM from "../components/MOASPredmeti/AnalizaPoslovanjaM";
import KontrolaRevizijaM from "../components/MOASPredmeti/KontrolaRevizijaM";
import PorodicniBiznis from "../components/MOASPredmeti/PorodicniBiznis";
import PreduzetnickiMenadzment from "../components/MOASPredmeti/PreduzetnickiMenadzment";
import MenadzmentBezbjednosti from "../components/MOASPredmeti/MenadzmentBezbjednosti";
import SigurnostZastitaIS from "../components/MOASPredmeti/SigurnostZastitaIS";
import PoslovnaPsihologija from "../components/MOASPredmeti/PoslovnaPsihologija";
import BiznisEtikaKultura from "../components/MOASPredmeti/BiznisEtikaKultura";

import IstorijaPrava from "../components/POASPredmeti/IstorijaPrava";
import UvodUPravo from "../components/POASPredmeti/UvodUPravo";
import RimskoPravo from "../components/POASPredmeti/RimskoPravo";
import OsnoviEkonomijeP from "../components/POASPredmeti/OsnoviEkonomijeP";
import InformacioneTehnologije from "../components/POASPredmeti/InformacioneTehnologije";
import UstavnoPravo from "../components/POASPredmeti/UstavnoPravo";
import UvodUPravoEvropskihIntegracija from "../components/POASPredmeti/UvodUPravoEvropskihIntegracija";
import EngleskiJezik1P from "../components/POASPredmeti/EngleskiJezik1P";
import GradjanskoPravo from "../components/POASPredmeti/GradjanskoPravo";
import PorodicnoPravo from "../components/POASPredmeti/PorodicnoPravo";
import ObligacionoPravo from "../components/POASPredmeti/ObligacionoPravo";
import UpravnoPravo from "../components/POASPredmeti/UpravnoPravo";
import RadnoPravo from "../components/POASPredmeti/RadnoPravo";
import KrivicnoPravo from "../components/POASPredmeti/KrivicnoPravo";
import NasljednoPravo from "../components/POASPredmeti/NasljednoPravo";
import OsnoviKompanijskogPrava from "../components/POASPredmeti/OsnoviKompanijskogPrava";
import MedjunarodnoJavnoPravo from "../components/POASPredmeti/MedjunarodnoJavnoPravo";
import EngleskiJezik2P from "../components/POASPredmeti/EngleskiJezik2P";
import KrivicnoProcesnoPravo from "../components/POASPredmeti/KrivicnoProcesnoPravo";
import GradjanskoProcesnoPravo from "../components/POASPredmeti/GradjanskoProcesnoPravo";
import MedjunarodnoPrivatnoPravo from "../components/POASPredmeti/MedjunarodnoPrivatnoPravo";
import SociologijaP from "../components/POASPredmeti/SociologijaP";
import PravnaEtikaKultura from "../components/POASPredmeti/PravnaEtikaKultura";
import AkademskoPisanje from "../components/POASPredmeti/AkademskoPisanje";
import StecajnoPravo from "../components/POASPredmeti/StecajnoPravo";
import KompanijskoPravo from "../components/POASPredmeti/KompanijskoPravo";
import PravoEvropskeUnije from "../components/POASPredmeti/PravoEvropskeUnije";
import LjudskaPravaISlobode from "../components/POASPredmeti/LjudskaPravaISlobode";
import PrekrsajnoPravo from "../components/POASPredmeti/PrekrsajnoPravo";
import NotarskoAdvokatskoPravo from "../components/POASPredmeti/NotarskoAdvokatskoPravo";

import MetodologijaNaucnoistrazivackogRadaPEM from "../components/PEMPredmeti/MetodologijaNaucnoistrazivackogRadaPEM";
import MarketingMenadzmentPEM from "../components/PEMPredmeti/MarketingMenadzmentPEM";
import UpravljanjeISPEM from "../components/PEMPredmeti/UpravljanjeISPEM";
import UpravljanjeOdnosimaSaJavnoscuPEM from "../components/PEMPredmeti/UpravljanjeOdnosimaSaJavnoscuPEM";
import FiskalniCarinskiMenadzmentPEM from "../components/PEMPredmeti/FiskalniCarinskiMenadzmentPEM";
import MedjunarodnoPrivrednoPravoPEM from "../components/PEMPredmeti/MedjunarodnoPrivrednoPravoPEM";
import LiderstvoPEM from "../components/PEMPredmeti/LiderstvoPEM";
import KorporativnoUpravljanjePEM from "../components/PEMPredmeti/KorporativnoUpravljanjePEM";
import MedjunarodnoPoslovanjePEM from "../components/PEMPredmeti/MedjunarodnoPoslovanjePEM";
import BiznisAnalizaPEM from "../components/PEMPredmeti/BiznisAnalizaPEM";
import BiznisPreduzetnistvoPEM from "../components/PEMPredmeti/BiznisPreduzetnistvoPEM";
import ElektronskiBiznisPEM from "../components/PEMPredmeti/ElektronskiBiznisPEM";
import UpravljanjeTroskovimaUPoslovnomOdlucivanjuPEM from "../components/PEMPredmeti/UpravljanjeTroskovimaUPoslovnomOdlucivanjuPEM";
import UpravljanjeInvesticijamaPEM from "../components/PEMPredmeti/UpravljanjeInvesticijamaPEM";
import PravoIntelektualneSvojinePEM from "../components/PEMPredmeti/PravoIntelektualneSvojinePEM";

import MetodologijaNaucnoistrazivackogRadaEJS from "../components/EJSPredmeti/MetodologijaNaucnoistrazivackogRadaEJS";
import MarketingMenadzmentEJS from "../components/EJSPredmeti/MarketingMenadzmentEJS";
import UpravljanjeISEJS from "../components/EJSPredmeti/UpravljanjeISEJS";
import UpravljanjeOdnosimaSaJavnoscuEJS from "../components/EJSPredmeti/UpravljanjeOdnosimaSaJavnoscuEJS";
import FiskalniCarinskiMenadzmentEJS from "../components/EJSPredmeti/FiskalniCarinskiMenadzmentEJS";
import MedjunarodnoPrivrednoPravoEJS from "../components/EJSPredmeti/MedjunarodnoPrivrednoPravoEJS";
import LiderstvoEJS from "../components/EJSPredmeti/LiderstvoEJS";
import KorporativnoUpravljanjeEJS from "../components/EJSPredmeti/KorporativnoUpravljanjeEJS";
import MedjunarodnoPoslovanjeEJS from "../components/EJSPredmeti/MedjunarodnoPoslovanjeEJS";
import EkonomijaJavnogSektoraEJS from "../components/EJSPredmeti/EkonomijaJavnogSektoraEJS";
import StrateskiMenadzmentJavnogSektoraEJS from "../components/EJSPredmeti/StrateskiMenadzmentJavnogSektoraEJS";
import MenadzmentNeprofitnihOrganizacijaEJS from "../components/EJSPredmeti/MenadzmentNeprofitnihOrganizacijaEJS";
import MenadzmentObrazovanjaKultureEJS from "../components/EJSPredmeti/MenadzmentObrazovanjaKultureEJS";
import OdrziviRazvojEkoloskiMenadzmentEJS from "../components/EJSPredmeti/OdrziviRazvojEkoloskiMenadzmentEJS";
import PravoIntelektualneSvojineEJS from "../components/EJSPredmeti/PravoIntelektualneSvojineEJS";

import MetodologijaNaucnoistrazivackogRadaPM from "../components/PMPredmeti/MetodologijaNaucnoistrazivackogRadaPM";
import PravnoNormiranjePM from "../components/PMPredmeti/PravnoNormiranjePM";
import OrganizacijaPravosudjaPM from "../components/PMPredmeti/OrganizacijaPravosudjaPM";
import FinansijskoPravoPM from "../components/PMPredmeti/FinansijskoPravoPM";
import MedjunarodnoKrivicnoPravoPM from "../components/PMPredmeti/MedjunarodnoKrivicnoPravoPM";
import MedjunarodnoGradjanskoProcesnoPravoPM from "../components/PMPredmeti/MedjuanrodnoGradjanskoProcesnoPravoPM";
import PravoIntelektualneSvojinePM from "../components/PMPredmeti/PravoIntelektualneSvojinePM";
import MedjunarodnoPrivrednoPravoPM from "../components/PMPredmeti/MedjunarodnoPrivrednoPravoPM";
import UgovornoPravoPM from "../components/PMPredmeti/UgovornoPravoPM";
import ArbitraznoPravoPM from "../components/PMPredmeti/ArbitraznoPravoPM";
import MedjunarodneOrganizacijePM from "../components/PMPredmeti/MedjunarodneOrganizacijePM";
import KorporativnoUpravljanjePM from "../components/PMPredmeti/KorporativnoUpravljanjePM";
import MaloljetnickoKrivicnoPravoPM from "../components/PMPredmeti/MaloljetnickoKrivicnoPravoPM";
import VanparnicniIzvrsniPostupakPM from "../components/PMPredmeti/VanparnicniIzvrsniPostupakPM";
import DiplomatskoKonzularnoPravoPM from "../components/PMPredmeti/DiplomatskoKonzularnoPravoPM";

import OUniverzitetu from "../components/Onama/OUniverzitetu";
import OFakultetu from "../components/Onama/OFakultetu";
import Osnivac from "../components/Onama/o-fpep/Osnivac";
import RijecDekana from "../components/Onama/o-fpep/RijecDekana";
import MisijaCiljevi from "../components/Onama/o-fpep/MisijaCiljevi";
import StrategijaRazvoja from "../components/Onama/o-fpep/StrategijaRazvoja";
import NastavnoOsoblje from "../components/Onama/NastavnoOsoblje";
import NajcescaPitanja from "../components/Onama/NajcescaPitanja";

import AkademskiIntegritet from "../components/PravniAkti/AkademskiIntegritet";
import IzdavackaDjelatnost from "../components/PravniAkti/IzdavackaDjelatnost";
import NaucnoistrazivackiRad from "../components/PravniAkti/NaucnoistrazivackiRad";
import ObezbjedjivanjeKvaliteta from "../components/PravniAkti/ObezbjedjivanjeKvaliteta";
import ModelStudentskePrakse from "../components/PravniAkti/ModelStudentskePrakse";
import Ankete from "../components/PravniAkti/Ankete";

import Erasmus from "../components/MedjunarodnaSaradnja/Erasmus";
import Projekti from "../components/MedjunarodnaSaradnja/Projekti";
import OCrnojGori from "../components/MedjunarodnaSaradnja/OCrnojGori";
import OBaru from "../components/MedjunarodnaSaradnja/OBaru";
import ErasmusKonkursi from "../components/MedjunarodnaSaradnja/ErasmusKonkursi";

import StudentskiParlament from "../components/Studenti/StudentskiParlament";
import DozvoleZaRad from "../components/PravniAkti/DozvoleZaRad";
import DomStudentata from "../components/Studenti/DomStudenata";
import AlumniKlub from "../components/Studenti/AlumniKlub";
import ProjectSingleDIGICREATE from "../components/Projekti/ProjectSingleDIGICREATE";

function Index() {
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    window.scroll(0, 0);
  }, [path]);

  return (
    <>
      <RouteSeo />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upis" element={<Upis />} />
        <Route path="/svi-studijski-programi" element={<Programi />} />
        <Route path="/o-nama" element={<Onama />} />
        <Route
          path="/medjunarodna-saradnja"
          element={<MedjunarodnaSaradnja />}
        />
        <Route path="/studenti" element={<Studenti />} />
        <Route
          path="/aktuelnosti/ljetnja-skola-bar-2026"
          element={<SummerSchoolBar2026Page />}
        />
        <Route path="/galerija" element={<Galerija />} />
        <Route path="/novosti" element={<Novosti />} />
        <Route path="/novosti/:id" element={<NovostiDetailPage />} />
        <Route path="/kontakt" element={<Kontakt />} />

        <Route path="/upisni-rokovi" element={<UpisniRokovi />} />
        <Route path="/cijene-studija" element={<CijeneStudija />} />
        <Route
          path="/prelazak-sa-drugih-fakulteta"
          element={<PrelazakSaDrugihFakulteta />}
        />
        <Route path="/akreditacija-fpep" element={<AkreditacijaFpep />} />

        {/* ============ PROGRAMI / SMJEROVI ==============*/}
        <Route
          path="/racunovodstvo-finansije-i-bankarstvo"
          element={<RacFinBan />}
        />
        <Route path="/menadzment" element={<Menadzment />} />
        <Route path="/pravo-osnovne" element={<PravoOsnovne />} />
        <Route path="/poslovna-ekonomija" element={<PoslovnaEkonomija />} />
        <Route
          path="/ekonomija-javnog-sektora"
          element={<EkonomijaJavnogSektora />}
        />
        <Route path="/pravo-master" element={<PravoMaster />} />
        <Route
          path="/specijalisticke-studije"
          element={<SpecijalistickeObavjestenje />}
        />
        <Route
          path="/menadzment-javnog-sektora-specijalisticke"
          element={<MenadzmentJavnogSektora />}
        />
        <Route
          path="/menadzment-profitnog-sektora-specijalisticke"
          element={<MenadzmentProfitnogSektora />}
        />

        {/* ============ PROJEKTI ==============*/}
        <Route
          path="/projekti/erasmus-ka171-connecting-continents"
          element={<ProjectSingleKA171 />}
        />
        <Route path="/projekti/res-uni" element={<ProjectSingleRESUNI />} />
        <Route path="/projekti/lands" element={<ProjectSingleLANDS />} />
        <Route
          path="/projekti/reimagine"
          element={<ProjectSingleREIMAGINE />}
        />
        <Route
          path="/projekti/digicreate"
          element={<ProjectSingleDIGICREATE />}
        />
        <Route path="/projekti/prodigy-e" element={<ProjectSinglePRODIGYE />} />

        {/* ============ RFB PREDMETI ==============*/}
        <Route path="/osnovi-ekonomije-rfb" element={<OsnoviEkonomije />} />
        <Route
          path="/ekonomika-preduzeca-rfb"
          element={<EkonomikaPreduzeca />}
        />
        <Route
          path="/matematicko-statisticke-metode-rfb"
          element={<MatematickoStatistickeMetode />}
        />
        <Route
          path="/poslovna-informatika-rfb"
          element={<PoslovnaInformatika />}
        />
        <Route path="/menadzment-predmet-rfb" element={<MenadzmentPredmet />} />
        <Route path="/racunovodstvo-rfb" element={<RacunovodstvoPredmet />} />
        <Route
          path="/osnovi-kompanijskog-trgovinskog-prava-rfb"
          element={<OsnoviKompanijskogTrgovinskogPrava />}
        />
        <Route path="/engleski-jezik-I-rfb" element={<EngleskiJezik1 />} />
        <Route
          path="/menadzment-ljudskih-resursa-rfb"
          element={<MenadzmentLjudskihResursa />}
        />
        <Route
          path="/elektronsko-poslovanje-rfb"
          element={<ElektronskoPoslovanje />}
        />
        <Route
          path="/osnovi-preduzetnistva-rfb"
          element={<OsnoviPreduzetnistva />}
        />
        <Route path="/marketing-rfb" element={<Marketing />} />
        <Route path="/poslovne-finansije-rfb" element={<PoslovneFinansije />} />
        <Route path="/bankarstvo-rfb" element={<Bankarstvo />} />
        <Route
          path="/upravljacko-racunovodstvo-rfb"
          element={<UpravljackoRacunovodstvo />}
        />
        <Route path="/engleski-jezik-II-rfb" element={<EngleskiJezik2 />} />
        <Route
          path="/upravljanje-kvalitetom-rfb"
          element={<UpravljanjeKvalitetom />}
        />
        <Route
          path="/menadzment-malih-srednjih-preduzeca-rfb"
          element={<MenadzmentMalihSrednjihPreduzeca />}
        />
        <Route path="/sociologija-rfb" element={<Sociologija />} />
        <Route path="/logistika-rfb" element={<Logistika />} />
        <Route
          path="/poslovno-odlucivanje-rfb"
          element={<PoslovnoOdlucivanje />}
        />
        <Route
          path="/poslovna-kultura-i-organizaciono-ponasanje-rfb"
          element={<PoslovnaKulturaOrganizacionoPonasanje />}
        />
        <Route path="/analiza-poslovanja-rfb" element={<AnalizaPoslovanja />} />
        <Route path="/kontrola-i-revizija-rfb" element={<KontrolaRevizija />} />
        <Route
          path="/finansijska-trzista-berzansko-poslovanje-rfb"
          element={<FinansijskaTrzistaBerzanskoPoslovanje />}
        />
        <Route
          path="/monetarne-i-javne-finansije-rfb"
          element={<MonetarneJavneFinansije />}
        />
        <Route
          path="/carinsko-poslovanje-rfb"
          element={<CarinskoPoslovanje />}
        />
        <Route
          path="/transport-spedicija-i-poslovanje-rfb"
          element={<TransportSpedicijaOsiguranje />}
        />
        <Route
          path="/menadzment-u-sportu-rfb"
          element={<MenadzmentUSportu />}
        />
        <Route
          path="/ekonomika-sportskih-organizacija-rfb"
          element={<EkonomikaSportskihDogadjaja />}
        />
        {/* ============ MENADZMENT OSNOVNE PREDMETI ==============*/}
        <Route path="/osnovi-ekonomije-m" element={<OsnoviEkonomijeM />} />
        <Route path="/poslovna-ekonomika-m" element={<PoslovnaEkonomikaM />} />
        <Route
          path="/matematicko-statisticke-metode-m"
          element={<MatematickoStatistickeMetodeM />}
        />
        <Route
          path="/poslovna-informatika-m"
          element={<PoslovnaInformatikaM />}
        />
        <Route path="/menadzment-m" element={<MenadzmentPredmetM />} />
        <Route path="/racunovodstvo-m" element={<RacunovodstvoPredmetM />} />
        <Route
          path="/osnovi-kompanijskog-trgovinskog-prava-m"
          element={<OsnoviKompanijskogTrgovinskogPravaM />}
        />
        <Route path="/engleski-jezik-I-m" element={<EngleskiJezik1M />} />
        <Route
          path="/menadzment-ljudskih-resursa-m"
          element={<MenadzmentLjudskihResursaM />}
        />
        <Route
          path="/elektronsko-poslovanje-m"
          element={<ElektronskoPoslovanjeM />}
        />
        <Route
          path="/osnovi-preduzetnistva-m"
          element={<OsnoviPreduzetnistvaM />}
        />
        <Route path="/marketing-m" element={<MarketingM />} />
        <Route
          path="/strategijski-menadzment-m"
          element={<StrategijskiMenadzment />}
        />
        <Route path="/odrzivi-razvoj-m" element={<OdrziviRazvoj />} />
        <Route
          path="/upravljacko-racunovodstvo-m"
          element={<UpravljackoRacunovodstvoM />}
        />
        <Route path="/engleski-jezik-II-m" element={<EngleskiJezik2M />} />
        <Route
          path="/upravljanje-kvalitetom-m"
          element={<UpravljanjeKvalitetomM />}
        />
        <Route
          path="/menadzment-malih-srednjih-preduzeca-m"
          element={<MenadzmentMalihSrednjihPreduzecaM />}
        />
        <Route path="/sociologija-m" element={<SociologijaM />} />
        <Route path="/logistika-m" element={<LogistikaM />} />
        <Route
          path="/poslovno-odlucivanje-m"
          element={<PoslovnoOdlucivanjeM />}
        />
        <Route
          path="/poslovna-kultura-organizaciono-ponasanje-m"
          element={<PoslovnaKulturaOrganizacionoPonasanjeM />}
        />
        <Route path="/analiza-poslovanja-m" element={<AnalizaPoslovanjaM />} />
        <Route path="/kontrola-revizija-m" element={<KontrolaRevizijaM />} />
        <Route path="/porodicni-biznis-m" element={<PorodicniBiznis />} />
        <Route
          path="/preduzetnicki-menadzment-m"
          element={<PreduzetnickiMenadzment />}
        />
        <Route
          path="/menadzment-bezbjednosti-m"
          element={<MenadzmentBezbjednosti />}
        />
        <Route
          path="/sigurnost-zastita-IS-m"
          element={<SigurnostZastitaIS />}
        />
        <Route
          path="/poslovna-psihologija-m"
          element={<PoslovnaPsihologija />}
        />
        <Route
          path="/biznis-etika-kultura-m"
          element={<BiznisEtikaKultura />}
        />

        {/* ============ PRAVO OSNOVNE PREDMETI ==============*/}
        <Route path="/istorija-prava-poas" element={<IstorijaPrava />} />
        <Route path="/uvod-u-pravo-poas" element={<UvodUPravo />} />
        <Route path="/rimsko-pravo-poas" element={<RimskoPravo />} />
        <Route path="/osnovi-ekonomije-poas" element={<OsnoviEkonomijeP />} />
        <Route
          path="/informacione-tehnologije-poas"
          element={<InformacioneTehnologije />}
        />
        <Route path="/ustavno-pravo-poas" element={<UstavnoPravo />} />
        <Route
          path="/uvod-u-pravo-evropskih-integracija-poas"
          element={<UvodUPravoEvropskihIntegracija />}
        />
        <Route path="/engleski-jezik-I-poas" element={<EngleskiJezik1P />} />
        <Route path="/gradjansko-pravo" element={<GradjanskoPravo />} />
        <Route path="/porodicno-pravo-poas" element={<PorodicnoPravo />} />
        <Route path="/obligaciono-pravo-poas" element={<ObligacionoPravo />} />
        <Route path="/upravno-pravo-poas" element={<UpravnoPravo />} />
        <Route path="/radno-pravo-poas" element={<RadnoPravo />} />
        <Route path="/krivicno-pravo-poas" element={<KrivicnoPravo />} />
        <Route path="/nasljedno-pravo-poas" element={<NasljednoPravo />} />
        <Route
          path="/osnovi-kompanijskog-prava-poas"
          element={<OsnoviKompanijskogPrava />}
        />
        <Route
          path="/medjunarodno-javno-pravo-poas"
          element={<MedjunarodnoJavnoPravo />}
        />
        <Route path="/engleski-jezik-II-poas" element={<EngleskiJezik2P />} />
        <Route
          path="/krivicno-procesno-pravo-poas"
          element={<KrivicnoProcesnoPravo />}
        />
        <Route
          path="/gradjansko-procesno-pravo-poas"
          element={<GradjanskoProcesnoPravo />}
        />
        <Route
          path="/medjunarodno-procesno-pravo-poas"
          element={<MedjunarodnoPrivatnoPravo />}
        />
        <Route path="/sociologija-poas" element={<SociologijaP />} />
        <Route
          path="/pravna-etika-kultura-poas"
          element={<PravnaEtikaKultura />}
        />
        <Route path="/akademsko-pisanje-poas" element={<AkademskoPisanje />} />
        <Route path="/stecajno-pravo-poas" element={<StecajnoPravo />} />
        <Route path="/kompanijsko-pravo-poas" element={<KompanijskoPravo />} />
        <Route path="/pravo-eu-poas" element={<PravoEvropskeUnije />} />
        <Route
          path="/ljudksa-prava-i-slobode-poas"
          element={<LjudskaPravaISlobode />}
        />
        <Route path="/prekrsajno-pravo-poas" element={<PrekrsajnoPravo />} />
        <Route
          path="/notarsko-advokatsko-pravo-poas"
          element={<NotarskoAdvokatskoPravo />}
        />

        {/* ============ POSLOVNA EKONOMIJA MASTER PREDMETI ==============*/}
        <Route
          path="/metodologija-naucno-istrazivackog-rada-pem"
          element={<MetodologijaNaucnoistrazivackogRadaPEM />}
        />
        <Route
          path="/marketing-menadzment-pem"
          element={<MarketingMenadzmentPEM />}
        />
        <Route path="/upravljanje-is-pem" element={<UpravljanjeISPEM />} />
        <Route
          path="/upravljanje-odnosima-sa-javnoscu-pem"
          element={<UpravljanjeOdnosimaSaJavnoscuPEM />}
        />
        <Route
          path="/fiskalni-i-carinski-menadzment-pem"
          element={<FiskalniCarinskiMenadzmentPEM />}
        />
        <Route
          path="/medjunarodno-privredno-pravo-pem"
          element={<MedjunarodnoPrivrednoPravoPEM />}
        />
        <Route path="/liderstvo-pem" element={<LiderstvoPEM />} />
        <Route
          path="/korporativno-upravljanje-pem"
          element={<KorporativnoUpravljanjePEM />}
        />
        <Route
          path="/medjunarodno-poslovanje-pem"
          element={<MedjunarodnoPoslovanjePEM />}
        />
        <Route path="/biznis-analiza-pem" element={<BiznisAnalizaPEM />} />
        <Route
          path="/biznis-i-preduzetnistvo-pem"
          element={<BiznisPreduzetnistvoPEM />}
        />
        <Route
          path="/elektronski-biznis-pem"
          element={<ElektronskiBiznisPEM />}
        />
        <Route
          path="/upravljanje-troskovima-u-poslovnom-odlucivanju-pem"
          element={<UpravljanjeTroskovimaUPoslovnomOdlucivanjuPEM />}
        />
        <Route
          path="/upravljanje-investicijama-pem"
          element={<UpravljanjeInvesticijamaPEM />}
        />
        <Route
          path="/pravo-intelektualne-svojine-pem"
          element={<PravoIntelektualneSvojinePEM />}
        />

        {/* ============ EKONOMIJA JAVNOG SEKTORA MASTER PREDMETI ==============*/}
        <Route
          path="/metodologija-naucno-istrazivackog-rada-ejs"
          element={<MetodologijaNaucnoistrazivackogRadaEJS />}
        />
        <Route
          path="/marketing-menadzment-ejs"
          element={<MarketingMenadzmentEJS />}
        />
        <Route path="/upravljanje-is-ejs" element={<UpravljanjeISEJS />} />
        <Route
          path="/upravljanje-odnosima-sa-javnoscu-ejs"
          element={<UpravljanjeOdnosimaSaJavnoscuEJS />}
        />
        <Route
          path="/fiskalni-i-carinski-menadzment-ejs"
          element={<FiskalniCarinskiMenadzmentEJS />}
        />
        <Route
          path="/medjunarodno-privredno-pravo-ejs"
          element={<MedjunarodnoPrivrednoPravoEJS />}
        />
        <Route path="/liderstvo-ejs" element={<LiderstvoEJS />} />
        <Route
          path="/korporativno-upravljanje-ejs"
          element={<KorporativnoUpravljanjeEJS />}
        />
        <Route
          path="/medjunarodno-poslovanje-ejs"
          element={<MedjunarodnoPoslovanjeEJS />}
        />
        <Route
          path="/ekonomija-javnog-sektora-ejs"
          element={<EkonomijaJavnogSektoraEJS />}
        />
        <Route
          path="/strateski-menadzment-javnog-sektora-ejs"
          element={<StrateskiMenadzmentJavnogSektoraEJS />}
        />
        <Route
          path="/menadzment-neprofitnih-organizacija-ejs"
          element={<MenadzmentNeprofitnihOrganizacijaEJS />}
        />
        <Route
          path="/menadzment-obrazovanja-i-kulture-ejs"
          element={<MenadzmentObrazovanjaKultureEJS />}
        />
        <Route
          path="/odrzivi-razvoj-i-ekoloski-menadzment-ejs"
          element={<OdrziviRazvojEkoloskiMenadzmentEJS />}
        />
        <Route
          path="/pravo-intelektualne-svojine-ejs"
          element={<PravoIntelektualneSvojineEJS />}
        />

        {/* ============ PRAVO MASTER PREDMETI ==============*/}
        <Route
          path="/metodologija-naucno-istrazivackog-rada-pm"
          element={<MetodologijaNaucnoistrazivackogRadaPM />}
        />
        <Route path="/pravno-normiranje-pm" element={<PravnoNormiranjePM />} />
        <Route
          path="/organizacija-pravosudja-pm"
          element={<OrganizacijaPravosudjaPM />}
        />
        <Route path="/finansijsko-pravo-pm" element={<FinansijskoPravoPM />} />
        <Route
          path="/medjunarodno-krivicno-pravo-pm"
          element={<MedjunarodnoKrivicnoPravoPM />}
        />
        <Route
          path="/medjunarodno-gradjansko-procesno-pravo-pm"
          element={<MedjunarodnoGradjanskoProcesnoPravoPM />}
        />
        <Route
          path="/pravo-intelektualne-svojine-pm"
          element={<PravoIntelektualneSvojinePM />}
        />
        <Route
          path="/medjunarodno-privredno-pravo-pm"
          element={<MedjunarodnoPrivrednoPravoPM />}
        />
        <Route path="/ugovorno-pravo-pm" element={<UgovornoPravoPM />} />
        <Route path="/arbitrazno-pravo-pm" element={<ArbitraznoPravoPM />} />
        <Route
          path="/medjunarodne-organizacije-pm"
          element={<MedjunarodneOrganizacijePM />}
        />
        <Route
          path="/korporativno-upravljanje-pm"
          element={<KorporativnoUpravljanjePM />}
        />
        <Route
          path="/maloljetnicko-krivicno-pravo-pm"
          element={<MaloljetnickoKrivicnoPravoPM />}
        />
        <Route
          path="/vanparnicni-i-izvrsni-postupak-pm"
          element={<VanparnicniIzvrsniPostupakPM />}
        />
        <Route
          path="/diplomatsko-i-konzularno-pravo-pm"
          element={<DiplomatskoKonzularnoPravoPM />}
        />

        {/* ============ MENADZMENT JAVNOG SEKTORA SPECIJALISTICKE PREDMETI ==============*/}

        {/* ============ MENADZMENT PROFITNOG SEKTORA SPECIJALISTICKE PREDMETI ==============*/}

        {/* ============ O NAMA SEKCIJA  ==============*/}
        <Route path="/o-univerzitetu" element={<OUniverzitetu />} />
        <Route path="/o-fpep" element={<OFakultetu />} />
        <Route path="/osnivac" element={<Osnivac />} />
        <Route path="/rijec-dekana" element={<RijecDekana />} />
        <Route
          path="/strategija-razvoja-fpep-2026-2029"
          element={<StrategijaRazvoja />}
        />
        <Route
          path="/misija-vizija-i-vrijednosti"
          element={<MisijaCiljevi />}
        />
        <Route path="/nastavno-osoblje" element={<NastavnoOsoblje />} />
        <Route path="/najcesca-pitanja" element={<NajcescaPitanja />} />

        <Route path="/dozvole-za-rad" element={<DozvoleZaRad />} />
        <Route path="/akademski-integritet" element={<AkademskiIntegritet />} />
        <Route path="/izdavacka-djelatnost" element={<IzdavackaDjelatnost />} />
        <Route
          path="/naucnoistrazivacki-rad"
          element={<NaucnoistrazivackiRad />}
        />
        <Route
          path="/obezbjedjivanje-kvaliteta"
          element={<ObezbjedjivanjeKvaliteta />}
        />
        <Route path="/obezbjedjivanje-kvaliteta/ankete" element={<Ankete />} />
        <Route
          path="/model-studentske-prakse"
          element={<ModelStudentskePrakse />}
        />

        {/* ============ MEDJUNARODNA SARADNJA SEKCIJA ==============*/}
        <Route path="/erasmus" element={<Erasmus />} />
        <Route path="/projekti" element={<Projekti />} />
        <Route path="/o-crnoj-gori" element={<OCrnojGori />} />
        <Route path="/o-baru" element={<OBaru />} />
        <Route path="/erasmus-konkursi" element={<ErasmusKonkursi />} />

        {/* ============ STUDENTI SEKCIJA  ==============*/}
        <Route path="/studentski-parlament" element={<StudentskiParlament />} />
        <Route path="/dom-studenata" element={<DomStudentata />} />
        <Route path="/alumni-klub" element={<AlumniKlub />} />
      </Routes>
    </>
  );
}

export default Index;
